import axios, { AxiosStatusCode } from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as session from 'smg/customer-api/session';
import { ReportValidity } from 'smg/form';
import { G } from 'smg/querystring';
import { Relref } from '../hugo';
import * as passwordresets from '../passwordresets';

export default function main() {
    const password = document.querySelector('#password') as HTMLInputElement;
    const confirmPassword = document.querySelector('#confirm-password') as HTMLInputElement;
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const header = form.querySelector('h1') as HTMLElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'not-found') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        header.after(a);
    };

    confirmPassword.addEventListener('input', () => confirmPassword.setCustomValidity(''));

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    form.noValidate = true;
    form?.addEventListener('submit', e => {
        e.preventDefault();

        if (confirmPassword.value !== password.value) {
            confirmPassword.setCustomValidity('Passwords do not match');
        }

        if (!ReportValidity(form)) {
            return false;
        }

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        axios.patch<passwordresets.UseResponse>(`/password-resets/${G().Get('id') ?? ''}/used`, {
            'password': password.value,
            'confirmPassword': confirmPassword.value,
        }).then(resp => {
            session.SetLoginToken(resp.data.token);
            window.location.href = Relref('/dashboard');
        }).catch(err => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            switch (AxiosStatusCode(err)) {
            case 404:
                showAlert('not-found');
                return;
            }

            showAlert('generic');
        });
    });
}